/* eslint-disable */
// @flow
import _isEmpty from 'lodash/isEmpty';
import _some from 'lodash/some';
import _get from 'lodash/get';
import TRegEx from './constant';
export var HTTP_CODES = {
  OK: 200,
  CREATED: 201
};

var isEmpty = function isEmpty(value) {
  return value === undefined || value === null || value === '';
};

var join = function join(rules) {
  return function (value, data) {
    return rules.map(function (rule) {
      return rule(value, data);
    }).filter(function (error) {
      return !!error;
    })[0];
  };
};

export function email(value) {
  // email regex.
  if (!isEmpty(value) && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    return 'Invalid email address';
  }
}
export function phoneNumber(value) {
  if (!isEmpty(value) && !isValidPhoneNo(value)) return 'Invalid phone number';
}
export function isValidPhoneNo(value) {
  return TRegEx.GENERAL.REG_EXPR.PHONE_REG_EXPR.test(value);
}
export function userNameOrEmail(value) {
  if (!isEmpty(value) && /\@+/gi.test(value)) {
    return email(value);
  }
}
export function required(value) {
  if (isEmpty(value)) {
    return 'Required';
  }
}
export function minLength(min) {
  return function (value) {
    if (!isEmpty(value) && value.length < min) {
      return "Must be at least ".concat(min, " characters");
    }
  };
}
export function maxLength(max) {
  return function (value) {
    if (!isEmpty(value) && value.length > max) {
      return "Must be no more than ".concat(max, " characters");
    }
  };
}
export function integer(value) {
  if (!Number.isInteger(Number(value))) {
    return 'Must be an integer';
  }
}
export function oneOf(enumeration) {
  return function (value) {
    if (!~enumeration.indexOf(value)) {
      return "Must be one of: ".concat(enumeration.join(', '));
    }
  };
}
export function match(field) {
  return function (value, data) {
    if (data) {
      if (value !== data[field]) {
        return 'Do not match';
      }
    }
  };
}
export function createValidator(rules) {
  return function () {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var errors = {};
    Object.keys(rules).forEach(function (key) {
      var rule = join([].concat(rules[key])); // concat enables both functions and arrays of functions

      var error = rule(data[key], data);

      if (error) {
        errors[key] = error;
      }
    });
    return errors;
  };
}
export function isEmptyObject(obj) {
  return !_some(obj, _isEmpty);
}
export function isAPICallSuccessful(response) {
  var metaCode = response.statusCode || response.status;
  return metaCode && (metaCode === HTTP_CODES.OK || metaCode === HTTP_CODES.CREATED);
}
export var isAlphaNumericWithLimit = function isAlphaNumericWithLimit(value) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 40;
  if (isEmpty(value)) return false;
  var regex = new RegExp("^[A-Za-z0-9]{0,".concat(limit, "}$"));
  return regex.test(value);
};